/* tslint:disable */
/* eslint-disable */
/**
 * Private UI API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: ${project.version}
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ReportForDeviceResponseUpgradeRuleHistoryElements
 */
export interface ReportForDeviceResponseUpgradeRuleHistoryElements {
    /**
     * 
     * @type {string}
     * @memberof ReportForDeviceResponseUpgradeRuleHistoryElements
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof ReportForDeviceResponseUpgradeRuleHistoryElements
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof ReportForDeviceResponseUpgradeRuleHistoryElements
     */
    loaderVersion: string;
    /**
     * 
     * @type {string}
     * @memberof ReportForDeviceResponseUpgradeRuleHistoryElements
     */
    firmwareVersion: string;
    /**
     * 
     * @type {string}
     * @memberof ReportForDeviceResponseUpgradeRuleHistoryElements
     */
    uiVersion: string;
    /**
     * 
     * @type {Date}
     * @memberof ReportForDeviceResponseUpgradeRuleHistoryElements
     */
    dateHour: Date | null;
    /**
     * 
     * @type {string}
     * @memberof ReportForDeviceResponseUpgradeRuleHistoryElements
     */
    userEmail: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof ReportForDeviceResponseUpgradeRuleHistoryElements
     */
    isDisabled: boolean | null;
}

export function ReportForDeviceResponseUpgradeRuleHistoryElementsFromJSON(json: any): ReportForDeviceResponseUpgradeRuleHistoryElements {
    return ReportForDeviceResponseUpgradeRuleHistoryElementsFromJSONTyped(json, false);
}

export function ReportForDeviceResponseUpgradeRuleHistoryElementsFromJSONTyped(json: any, ignoreDiscriminator: boolean): ReportForDeviceResponseUpgradeRuleHistoryElements {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'name': json['name'],
        'loaderVersion': json['loaderVersion'],
        'firmwareVersion': json['firmwareVersion'],
        'uiVersion': json['uiVersion'],
        'dateHour': (json['dateHour'] === null ? null : new Date(json['dateHour'])),
        'userEmail': json['userEmail'],
        'isDisabled': json['isDisabled'],
    };
}

export function ReportForDeviceResponseUpgradeRuleHistoryElementsToJSON(value?: ReportForDeviceResponseUpgradeRuleHistoryElements | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'name': value.name,
        'loaderVersion': value.loaderVersion,
        'firmwareVersion': value.firmwareVersion,
        'uiVersion': value.uiVersion,
        'dateHour': (value.dateHour === null ? null : value.dateHour.toISOString()),
        'userEmail': value.userEmail,
        'isDisabled': value.isDisabled,
    };
}

